module.exports = __webpack_public_path__ + "img/icon_02.a563d52e.gif";